import { Component } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {BaseFeatureWelcomeComponent} from '@catapp/shared/feature/create-form-wizards/base-feature-welcome.component';
import {FeatureTypeService} from '@catcore/services';
import {FeatureOptionTokenService} from '@catmodules/models/feature-option-tokens/services/feature-option-token.service';
import {isNullOrUndefined} from 'util';

/**
 * A component to fast create a new FeatureOptionTokens for the currently in use Feature
 *
 */
@Component({
  selector: 'catapp-feature-option-tokens-welcome',
  templateUrl: './feature-option-tokens-welcome.component.html',
  styleUrls: ['./feature-option-tokens-welcome.component.scss'],
})
export class FeatureOptionTokensWelcomeComponent extends BaseFeatureWelcomeComponent {

  /**
   * The self-name to be used throughout the displayed elements.
   * Reference to the current used type of model
   * @type {string}
   */
  selfTitle = 'Option Token';

  /**
   * The title used by the form wizard component
   * @type {string}
   */
  title = `New ${this.selfTitle}`;

  /**
   * The token value
   *
   * @type {string}
   */
  value: string;

  /**
   * The token description
   *
   * @type {string}
   */
  description: string;

  /**
   * Label names to be used by form input elements.
   *
   * @type {{value: string; description: string;  buttons: {last: string}}}
   */
  labels = {
    value: 'Value',
    description: 'Description',
    buttons: {
      last: `Save the ${this.selfTitle}`,
    },
  };

  /**
   * Returns true if the current form object is ready.
   * Ready means all necessary data that is required to display and use the form, is available
   * @returns {boolean}
   */
  get formIsReady() {
    return !isNullOrUndefined(this.getFeature());
  }

  resetAfterComplete = true;

  constructor(private route: ActivatedRoute,
              private featureOptionTokenService: FeatureOptionTokenService,
              featureService: FeatureTypeService) {

    super(featureService);

    this.form = new FormGroup({
      value: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
    });
  }

  /**
   * Executes the request to create a new FeatureUnit
   *
   */
  /**
   * Creates a new entity
   *
   * The 'isVirtual' property needs to check explictly because it can still be NULL if the form was reset on one point
   */
  saveNewEntity() {
    this.featureOptionTokenService
      .create({
        value: this.form.value.value,
        description: this.form.value.description,
        featureType: this.getFeature()._links.self.href,
      })
      .subscribe((featureOptionToken) => {
        this.setCurrentEntity(featureOptionToken);
        this.setIsCompleted(featureOptionToken !== null);
        this.getFeatureService().refreshCurrent();
      });
  }

  validatePropertiesView() {
  }

  beforeDisplayProperties(): void {
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/components/landing-pages/feature-option-tokens-welcome/feature-option-tokens-welcome.component.ts